// update.js
import { makeAttrs } from './helpers';
import { flattener } from '../utilities';


export const update_user = (user, attrs) => {
  const attributeList = makeAttrs(attrs);
  return new Promise((resolve, reject) => {
    user.updateAttributes(attributeList, (error, result) => {
      if (error !== null) return reject(error);
      // need to clean the keys (remove 'custom:' from those fields that have it)
      // because of this we flatten the attribute list we've made, rather than just ship
      // `attrs`
      resolve(flattener(attributeList, attrs));
    });
  })
}



// WEBPACK FOOTER //
// ./src/utils/user/update.js